module.exports = __webpack_public_path__ + "img/symbol_1.f1d9e0f8.png";